import React, { useEffect, useRef, useState } from 'react'
import Nlayout from './Nlayout'
import {
    Button,
    Grid,
    Typography,
    TextField,
    CircularProgress,
    Box,
    Dialog,
} from '@mui/material'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from './authContext';
import { FaCloudUploadAlt } from 'react-icons/fa'
import paso1 from './Paso1-gif.gif'
import paso2 from './Paso2-gif.gif'
import paso3 from './Paso3-gif.gif'
import ej2 from './ejpaso2.jpg'
import ej3 from './ejpaso3.jpg'
/**
 * TipeoCustom completo:
 * - detecta tipo Instagram -> al click abre formulario multi-step
 * - multi-step incluye email en step 3 y handleRequestTipeo con Cloudinary
 *
 * Notas:
 * - Reemplazá los placeholders (paso1/paso2/paso3/ej2/ej3) por tus imágenes si las tenés.
 * - Si ya tenés una función openImage, la puede usar en lugar del fallback.
 */

const VisuallyHiddenInput = (props) => (
    <input style={{ display: 'none' }} {...props} />
);

async function getPublicIP() {
    try {
        const res = await fetch('https://api.ipify.org?format=json');
        const json = await res.json();
        return json.ip || '';
    } catch (e) {
        return '';
    }
}

function TipeoCustom(props) {
    const { url } = useParams();
    const navigate = useNavigate();
    const { username } = useAuth();

    const tipeo = true;

    const mail = localStorage.getItem('kick_mail');

    const [registrado, setRegistrado] = useState('');
    const [deshabilitar, setDeshabilitar] = useState(false);
    const [solicitud, setSolicitud] = useState();
    const [reclamado, setReclamado] = useState();
    const [mostrarFormulario, setMostrarFormulario] = useState(false);


    // --- Multi-step form states ---
    const [activeStep, setActiveStep] = useState(0); // 0..3
    const [email, setEmail] = useState('');
    const [nombre, setNombre] = useState('');
    const [offerScreenshot, setOfferScreenshot] = useState(null);
    const [offerScreenshotUrl, setOfferScreenshotUrl] = useState('');
    const [bnbScreenshot, setBnbScreenshot] = useState(null);
    const [bnbScreenshotUrl, setBnbScreenshotUrl] = useState('');
    const [bnbAddress, setBnbAddress] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deshabilitarBoton, setDeshabilitarBoton] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [triggerUpload, setTriggerUpload] = useState(null);
    const [mensajeInstagram, setMensajeInstagram] = useState(false);
    const [imagenModal, setImagenModal] = useState(false)
    const [previewImage, setPreviewImage] = useState()

    const obtenerSorteos = async () => {
        try {
            const peticion = await axios.get(`https://backend.eldenguee.com/solicitudes/${url}`);
            setSolicitud(peticion?.data);
        } catch (err) {
            console.error('Error obteniendo solicitud', err);
        }
    };

    const VerificarSolicitud = async (nombre) => {
        try {
            const peticion = await axios.post(`https://backend.eldenguee.com/solicitudes/${url}/verificar`, { nombre });
            setReclamado(peticion?.data?.reclamado);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        obtenerSorteos();
    }, []);

    const usuariosValidos = solicitud?.tipeo?.usuarios?.split(",");
    const isValid = usuariosValidos === undefined || usuariosValidos?.length < solicitud?.tipeo?.premios;

    const solicitarTipeo = async () => {
        try {
            const peticion = await axios.post(`https://backend.eldenguee.com/solicitudes/${url}/unirse`, { nombre });
            setReclamado(peticion?.data?.reclamado);

            if (!peticion?.data?.registrado) {
                await axios.post(`https://backend.eldenguee.com/sorteo/crearUser`, { nombre, mail, tipeo });
                navigate(`/tipeo`);
            } else {
                setRegistrado('Ya reclamaste el tipeo');
                setDeshabilitar(true);
            }
        } catch (err) {
            console.error(err);
        }
    };



    const handleAccionSegunTipo = () => {
        if (solicitud?.tipeo?.tipo === "Instagram" || solicitud?.tipeo?.tipo === "instagram") {
            // Mostrar mensaje verde
            setMensajeInstagram(true);

            // Después de 5 segundos -> mostrar formulario
            setTimeout(() => {
                setMensajeInstagram(false);
                setMostrarFormulario(true);
            }, 5000);

            return;
        } else {
            solicitarTipeo();

        }

        // Para los otros tipos, mostrar formulario normal
        // setMostrarFormulario(true);
    };
    // Helper para previews de archivos
    const handleFileChange = (setFile, setUrl) => async (event) => {
        const file = event.target.files[0];

        if (file) {
            setFile(file);
            try {
                setIsUploading(true)
                const url = await uploadToCloudinary(file);
                setUrl(url);
                setError('');
            } catch (err) {
                setError('Error al subir la imagen: ' + err.message);
            }
        }
    };
    const uploadToCloudinary = async (file) => {
        if (!file || !(file instanceof File)) {
            throw new Error('Archivo inválido');
        }
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('imagen', file);
            formData.append('file', file);
            formData.append('tipo', 'tipeos');
            const response = await fetch('https://backend.eldenguee.com/solicitudes/upload/tipeos', {
                method: 'POST',
                body: formData,
            });
            if (!response.ok) {
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.error || 'Error al subir la imagen al servidor');
            }
            const data = await response.json();
            return data.url || data.fileUrl || data.filename;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
            setIsUploading(false)
        }
    };
    const openImage = (img) => {
        if (!img) {
            alert('Imagen no disponible');
            return;
        }

        setPreviewImage(img);      // guardar imagen que se mostrará en el dialog
        setImagenModal(true); // abrir modal
    };


    // ---------------------------
    // handleRequestTipeo (INCLUYE email)
    // ---------------------------
    const handleRequestTipeo = async () => {
        setLoading(true);
        setError('');

        const ip = await getPublicIP();

        try {
            // VALIDAR EMAIL
            if (!email || !email.includes('@') || !email.includes('.')) {
                console.log(email)
                throw new Error('Debes ingresar un email válido');
            }

            // VALIDAR BNB
            if (!bnbAddress || !bnbAddress.startsWith('0x')) {
                throw new Error('UPS! eso no parece una dirección BNB');
            }

            // Validar placeholders de dirección ejemplo si querés exactamente el match
            if (
                activeStep === 2 &&
                (
                    bnbAddress?.toLowerCase() === '0x3f1bd53eb8a3f5d60147a5c0c47279a...' ||
                    bnbAddress?.toLowerCase() === '0x3f1bd53eb8a3f5d60147a5c0c47279a'
                )
            ) {
                setError('La dirección BNB debe ser una real.');
                setLoading(false);
                return false;
            }

            if (!offerScreenshot || !bnbScreenshot || !bnbAddress) {
                throw new Error('Todos los campos son obligatorios');
            }

            // SUBIR AL SERVIDOR
            const uploadToBackend = async (file) => {
                if (!file || !(file instanceof File)) {
                    throw new Error('Archivo inválido');
                }
                setIsUploading(true);
                const formData = new FormData();
                formData.append('imagen', file);
                formData.append('file', file);
                formData.append('tipo', 'tipeos');

                const response = await fetch('https://backend.eldenguee.com/solicitudes/upload/tipeos', {
                    method: 'POST',
                    body: formData,
                });

                setIsUploading(false);

                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || 'Error al subir la imagen al servidor');
                }
                const data = await response.json();
                return data.url || data.fileUrl || data.filename;
            };

            setDeshabilitarBoton(true);

            const offerScreenshotUrlUploaded = await uploadToBackend(offerScreenshot);
            const bnbScreenshotUrlUploaded = await uploadToBackend(bnbScreenshot);

            // ENVIAR AL BACKEND
            const response = await fetch('https://backend.eldenguee.com/solicitudes/submit-request', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre: nombre,
                    email,
                    offerScreenshot: offerScreenshotUrlUploaded,
                    bnbScreenshot: bnbScreenshotUrlUploaded,
                    bnbAddress,
                    ip,
                    solicitudId: url,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Error al enviar la solicitud');
            }

            setSuccess(true);
            // ENVIAR AL BACKEND
            const response2 = await fetch(`https://backend.eldenguee.com/solicitudes/tipeos/${url}/reclamar`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre: nombre,
                }),
            });
            // opcional: cerrar formulario o navegar
            // setMostrarFormulario(false);
            // navigate('/tipeo');
        } catch (err) {
            console.error(err);
            setError('Error: ' + (err.message || err));
        } finally {
            setLoading(false);
            setDeshabilitarBoton(false);
        }
    };
    const offerInputRef = useRef(null);

    const getStepContent = (step) => {
        switch (step) {
            case 1:
                return (
                    <Box>
                        <Box style={{ backgroundColor: '#1a2c38', display: 'flex', flexDirection: 'column', gap: '5px' }}>

                            <Box sx={{ backgroundColor: '#1e293b', p: 2, borderRadius: 1, mt: 2, border: '2px dashed #2a2e38' }}>
                                <Typography>
                                    Es obligatorio estar registrado con el siguiente enlace y el código <strong>"eldenguee"</strong> como muestra arriba
                                </Typography>

                                <a
                                    href="https://stake1020.com/?offer=eldenguee&c=1590cd3460"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'block',
                                        marginTop: 8,
                                        marginBottom: 8,
                                        color: '#4ade80',
                                        wordBreak: 'break-all',
                                    }}
                                >
                                    https://stake1020.com/?offer=eldenguee&c=1590cd3460
                                </a>
                            </Box>
                            <Typography sx={{ fontWeight: 'bold', mb: 1, display: 'inline-block' }}>
                                Instrucciones:
                            </Typography>
                            <Button onClick={() => openImage(paso1)} style={{ margin: '0 auto', display: 'flex', background: 'red', color: 'white' }}>Ver tutorial</Button>
                        </Box>

                        <Button
                            variant="contained"
                            onClick={() => setActiveStep(prev => prev + 1)}
                            sx={{
                                mt: 3,
                                backgroundColor: '#3b82f6',
                                '&:hover': {
                                    backgroundColor: '#2563eb',
                                },
                                width: '100%',
                            }}
                        >
                            SIGUIENTE
                        </Button>

                        <Typography sx={{ mt: 2 }}>
                            Necesitas estar registrado con este enlace porque luego se pedirá una captura de <strong>Ajustes - Ofertas</strong> para verificar que estás vinculado a este código.
                        </Typography>
                    </Box>
                );
            case 0:
                return (
                    <Box sx={{ p: 2 }}>
                        <Typography sx={{ color: '#fff', fontWeight: 'bold', mb: 1 }}>
                            SI SOS DE ARGENTINA Y NO ESTAS REGISTRADO EN STAKE MIRA ESTE VIDEO!
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: '#1e293b',
                                borderRadius: 2,
                                p: 2,
                                color: '#cbd5e1',
                                mb: 2,
                            }}
                            style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px', border: '2px dashed #2a2e38' }}
                        >
                            <video src="https://res.cloudinary.com/dgz8kxs5o/video/upload/v1767407306/l6ki7zcifjz9many0s5i.mp4" controls style={{ width: '100%' }}></video>
                            <Box sx={{ backgroundColor: '#1e293b', p: 2, borderRadius: 1, mt: 2, border: '2px dashed #2a2e38' }}>
                                <Typography>
                                    Es obligatorio estar registrado con el siguiente enlace y el código <strong>"eldenguee"</strong> como muestra arriba
                                </Typography>

                                <a
                                    href="https://stake1020.com/?offer=eldenguee&c=1590cd3460"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'block',
                                        marginTop: 8,
                                        marginBottom: 8,
                                        color: '#4ade80',
                                        wordBreak: 'break-all',
                                    }}
                                >
                                    https://stake1020.com/?offer=eldenguee&c=1590cd3460
                                </a>
                            </Box>
                        </Box>
                        <Button
                            variant="contained"
                            onClick={() => setActiveStep(prev => prev + 1)}
                            sx={{
                                backgroundColor: '#3b82f6',
                                flex: 1,
                                '&:hover': {
                                    backgroundColor: '#2563eb',
                                },
                            }}
                        >
                            Siguiente
                        </Button>
                    </Box>
                );
            case 2:
                return (
                    <Box sx={{ p: 2 }}>
                        <Typography sx={{ color: '#fff', fontWeight: 'bold', mb: 1 }}>
                            Sube la captura de pantalla de Ajustes - Ofertas
                        </Typography>
                        <Button onClick={() => openImage(paso2)} style={{ margin: '0 auto', display: 'flex', background: 'red', color: 'white' }}>Ver tutorial</Button>

                        <Box
                            sx={{
                                backgroundColor: '#1e293b',
                                borderRadius: 2,
                                p: 2,
                                color: '#cbd5e1',
                                mb: 2,
                            }}
                            style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px', border: '2px dashed #2a2e38' }}
                        >
                            <Box
                                sx={{
                                    borderBottom: '1px solid #334155',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    pb: 1,
                                    mb: 1,
                                    fontWeight: 'bold',
                                }}
                            >
                                <Typography>Tu imagen</Typography>
                                <Typography>
                                    {offerScreenshot ? `Archivo seleccionado: ${offerScreenshot.name}` : 'No hay archivo'}
                                </Typography>
                            </Box>
                            {
                                isUploading ?
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                        <CircularProgress size={30} color="inherit" />
                                    </Box>
                                    :
                                    (offerScreenshotUrl ?
                                        <img src={offerScreenshotUrl} style={{ width: '20%', borderRadius: '5px', margin: '0 auto', display: 'flex' }} />
                                        : <Box sx={{ color: '#94a3b8', textAlign: 'center' }}>No hay preview</Box>)
                            }

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Button
                                    component="label"
                                    variant="contained"
                                    startIcon={<FaCloudUploadAlt />}
                                    sx={{
                                        backgroundColor: '#334155',
                                        color: '#fff',
                                        flex: 1,
                                        '&:hover': {
                                            backgroundColor: '#475569',
                                        },
                                    }}
                                    onClick={() => {
                                        setTriggerUpload(() => () =>
                                            document.getElementById('offerScreenshotInput').click()
                                        );
                                        setShowWarningModal(true);
                                    }}
                                >
                                    Cargar imagen

                                </Button>
                                <VisuallyHiddenInput
                                    id="offerScreenshotInput"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange(setOfferScreenshot, setOfferScreenshotUrl)}
                                />

                                <Button
                                    variant="contained"
                                    onClick={() => setActiveStep(prev => prev + 1)}
                                    disabled={!offerScreenshot}
                                    sx={{
                                        backgroundColor: '#3b82f6',
                                        flex: 1,
                                        '&:hover': {
                                            backgroundColor: '#2563eb',
                                        },
                                    }}
                                >
                                    Siguiente
                                </Button>
                            </Box>
                        </Box>

                        <Box style={{ backgroundColor: '#0c1b26', padding: 10, borderRadius: 5 }}>
                            <Typography
                                sx={{
                                    color: '#94a3b8',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                                onClick={() => openImage(ej2)}
                            >
                                Click para ver ejemplo de captura
                            </Typography>
                        </Box>
                    </Box>
                );
            case 3:
                return (
                    <Box sx={{ p: 2 }}>
                        <Typography sx={{ color: '#fff', fontWeight: 'bold', mb: 1 }}>
                            Sube la captura del QR y tu dirección BNB
                        </Typography>
                        <Button onClick={() => openImage(paso3)} style={{ margin: '0 auto', display: 'flex', background: 'red', color: 'white' }}>Ver tutorial</Button>

                        <Box
                            sx={{
                                backgroundColor: '#1e293b',
                                borderRadius: 2,
                                p: 2,
                                color: '#cbd5e1',
                                mb: 2,
                            }}
                            style={{ marginTop: '15px', border: '2px dashed #2a2e38' }}
                        >
                            <Box
                                sx={{
                                    borderBottom: '1px solid #334155',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    pb: 1,
                                    mb: 1,
                                    fontWeight: 'bold',
                                }}
                            >
                                <Typography>Tu imagen</Typography>
                                <Typography>
                                    {bnbScreenshot ? `Archivo seleccionado: ${bnbScreenshot.name}` : 'No hay archivo'}
                                </Typography>

                            </Box>
                            {
                                isUploading ?
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                        <CircularProgress size={30} color="inherit" />
                                    </Box>
                                    :
                                    (bnbScreenshotUrl ?
                                        <img src={bnbScreenshotUrl} style={{ width: '20%', borderRadius: '5px', margin: '0 auto', display: 'flex' }} />
                                        : <Box sx={{ color: '#94a3b8', textAlign: 'center' }}>No hay preview</Box>)
                            }
                            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                                <Button
                                    component="label"
                                    variant="contained"
                                    startIcon={<FaCloudUploadAlt />}
                                    sx={{
                                        backgroundColor: '#334155',
                                        color: '#fff',
                                        flex: 1,
                                        '&:hover': {
                                            backgroundColor: '#475569',
                                        },
                                    }}
                                    onClick={() => {
                                        setTriggerUpload(() => () =>
                                            document.getElementById('bnbScreenshotInput').click()
                                        );
                                        setShowWarningModal(true);
                                    }}
                                >
                                    Cargar imagen
                                </Button>
                                <VisuallyHiddenInput
                                    id="bnbScreenshotInput"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange(setBnbScreenshot, setBnbScreenshotUrl)}
                                />

                                <Button
                                    variant="contained"
                                    onClick={() => setActiveStep(prev => prev + 1)}
                                    disabled={!bnbScreenshot}
                                    sx={{
                                        backgroundColor: '#3b82f6',
                                        flex: 1,
                                        '&:hover': {
                                            backgroundColor: '#2563eb',
                                        },
                                    }}
                                >
                                    Siguiente
                                </Button>

                            </Box>
                        </Box>



                        <Typography sx={{ color: '#fff', fontWeight: 500, mb: 0 }}>
                            Pegá la direccion BNB que figura en tu cuenta acá abajo
                        </Typography>

                        <TextField
                            fullWidth
                            value={bnbAddress}
                            onChange={(e) => setBnbAddress(e.target.value)}
                            variant="outlined"
                            sx={{
                                mt: 2,
                                backgroundColor: '#0c1b26',
                                borderRadius: '8px',
                                mb: 3,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { borderColor: '#2c4454' },
                                    '&:hover fieldset': { borderColor: '#3e5d6f' },
                                    '&.Mui-focused fieldset': { borderColor: '#5da6d6' },
                                    input: { color: 'white' },
                                },
                            }}
                            InputProps={{
                                style: { height: '44px' },
                            }}
                        />



                        <Box style={{ backgroundColor: '#0c1b26', padding: 10, borderRadius: 5 }}>
                            <Typography
                                sx={{
                                    color: '#94a3b8',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                                onClick={() => openImage(ej3)}
                            >
                                Click para ver ejemplo de captura
                            </Typography>
                        </Box>
                    </Box>
                );
            case 4:
                return (
                    <Box sx={{ p: 2 }}>
                        <Typography sx={{ color: '#fff', fontWeight: 'bold', mb: 1 }}>
                            Datos de Contacto
                        </Typography>


                        <Box
                            sx={{
                                backgroundColor: '#1e293b',
                                borderRadius: 2,
                                p: 2,
                                color: '#cbd5e1',
                                mb: 2,
                            }}
                            style={{ marginTop: '15px', border: '2px dashed #2a2e38' }}
                        >


                            {/* EMAIL FIELD */}
                            <Typography sx={{ color: '#fff', fontWeight: 500 }}>
                                Ingresa tu correo electrónico donde queres que te llegue la confirmación de tu tipeo!
                            </Typography>

                            <TextField
                                fullWidth
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="ejemplo@gmail.com"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#0c1b26',
                                    borderRadius: '8px',
                                    mb: 3,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#2c4454' },
                                        '&:hover fieldset': { borderColor: '#3e5d6f' },
                                        '&.Mui-focused fieldset': { borderColor: '#5da6d6' },
                                        input: { color: 'white' },
                                    },
                                }}
                                InputProps={{ style: { height: '44px' } }}
                            />

                            <Typography sx={{ color: '#fff', fontWeight: 500 }}>
                                Ingresa tu nombre
                            </Typography>
                            <TextField
                                fullWidth
                                type="text"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                placeholder="Por ejemplo: eldenguee"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#0c1b26',
                                    borderRadius: '8px',
                                    mb: 3,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#2c4454' },
                                        '&:hover fieldset': { borderColor: '#3e5d6f' },
                                        '&.Mui-focused fieldset': { borderColor: '#5da6d6' },
                                        input: { color: 'white' },
                                    },
                                }}
                                InputProps={{ style: { height: '44px' } }}
                            />


                            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>

                                <Button
                                    variant="contained"
                                    onClick={handleRequestTipeo}
                                    disabled={!bnbScreenshot || !email || deshabilitarBoton}
                                    sx={{
                                        backgroundColor: '#3b82f6',
                                        flex: 1,
                                        '&:hover': {
                                            backgroundColor: '#2563eb',
                                        },
                                    }}
                                >
                                    {deshabilitarBoton || loading ? 'Enviando solicitud' : 'Terminar'}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                );
            default:
                return null;
        }
    };

    // preview cleanups (liberar object urls cuando se destruye)
    useEffect(() => {
        return () => {
            if (offerScreenshotUrl) URL.revokeObjectURL(offerScreenshotUrl);
            if (bnbScreenshotUrl) URL.revokeObjectURL(bnbScreenshotUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Cuando success cambia a true → esperar 2s → ir al home
    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => {
                navigate('/');
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [success, navigate]);
    // render
    return (

        <Grid style={{ width: '100%' }} >
            {isValid ? (
                <>
                    {mensajeInstagram && (
                        <Grid sx={{
                            textAlign: "center",
                            mt: 10,
                            mb: 10,
                            p: 3,
                            maxWidth: 600,
                            margin: "0 auto",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: 2,
                            fontSize: 18,
                            fontWeight: "bold",
                            boxShadow: "0px 0px 12px rgba(0,0,0,0.2)"
                        }}>
                            🎉 Felicitaciones, conseguiste un tipeo en Stake!
                            <br />
                            <span style={{ fontWeight: "normal" }}>
                                En 5 segundos te vamos a redirigir al formulario para reclamar tu premio.
                            </span>
                            <br /><br />
                            <CircularProgress size={30} sx={{ color: "white" }} />
                        </Grid>
                    )}
                    {/* BOTÓN PRINCIPAL (si NO estamos mostrando el formulario) */}
                    {!mostrarFormulario && !mensajeInstagram && (
                        <Grid sx={{ textAlign: "center", mt: 16, mb: 16 }}>

                            <Button
                                variant="contained"
                                sx={{ mt: 3 }}
                                disabled={deshabilitar}
                                onClick={handleAccionSegunTipo}
                            >
                                {solicitud?.tipeo?.tipo?.toLowerCase() === "instagram"
                                    ? "Reclamar tipeo"
                                    : "Reclamar Tipeo"}
                            </Button>

                            {registrado && (
                                <Typography color="red" mt={2}>
                                    {registrado}
                                </Typography>
                            )}
                        </Grid>
                    )}

                    {/* FORMULARIO MULTI-STEP */}
                    {mostrarFormulario && (
                        <Grid
                            sx={{
                                maxWidth: 720,
                                margin: "40px auto",
                                padding: 3,
                                background: "#0b1620",
                                borderRadius: 2,
                                color: "white",
                            }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Paso {activeStep + 1}/5
                            </Typography>

                            <Box sx={{ minHeight: 380 }}>
                                {getStepContent(activeStep)}
                            </Box>

                            {/* MENSAJES DE ERROR / SUCCESS */}
                            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                                <Box sx={{ flex: 1, textAlign: "right" }}>
                                    {error && (
                                        <Typography color="error">{error}</Typography>
                                    )}

                                    {success && (
                                        <Grid sx={{
                                            textAlign: "center",
                                            mt: 10,
                                            mb: 10,
                                            p: 3,
                                            maxWidth: 600,
                                            margin: "0 auto",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                            borderRadius: 2,
                                            fontSize: 18,
                                            fontWeight: "bold",
                                            boxShadow: "0px 0px 12px rgba(0,0,0,0.2)"
                                        }}>
                                            🎉 Felicitaciones tu solicitud ha sido enviada
                                            <br />
                                            <span style={{ fontWeight: "normal" }}>
                                                cuando el tipeo esté acreditado te contactaremos a tu correo: {email}
                                            </span>
                                            <br /><br />
                                            <CircularProgress size={30} sx={{ color: "white" }} />
                                        </Grid>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    )}
                </>
            ) : (
                /* SI NO ES VÁLIDO → LIMITE DE PREMIOS */
                <Grid sx={{ textAlign: "center", mt: 16, mb: 16 }}>
                    <Box
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1.5,
                            px: 4,
                            py: 2,
                            borderRadius: 3,
                            backgroundColor: "error.light",
                            border: "2px solid",
                            borderColor: "error.main",
                            fontWeight: "bold",
                            fontSize: "1.2rem",
                            color: "error.dark",
                            boxShadow: 2
                        }}
                    >

                        LÍMITE ALCANZADO
                    </Box>
                </Grid>

            )}

            <Dialog
                open={showWarningModal}
                onClose={() => setShowWarningModal(false)}
                PaperProps={{
                    style: {
                        backgroundColor: '#0f172a',
                        color: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        maxWidth: '400px',
                    },
                }}
            >
                <Typography sx={{ fontWeight: 'bold', mb: 2 }}>
                    ⚠️ IMPORTANTE
                </Typography>

                <Typography sx={{ mb: 3 }}>
                    LA IMAGEN TIENE QUE SER TOMADA EL DÍA DE HOY Y NO TIENE QUE ESTAR RECORTADA.
                    EN CASO CONTRARIO EL SISTEMA DENEGARÁ LA SOLICITUD.
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setShowWarningModal(false);
                            if (triggerUpload) triggerUpload(); // abre input de imagen
                        }}
                        sx={{ backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' } }}
                    >
                        Aceptar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setShowWarningModal(false)}
                        sx={{ backgroundColor: '#ef4444', '&:hover': { backgroundColor: '#dc2626' } }}
                    >
                        Cancelar
                    </Button>
                </Box>
            </Dialog>

            <Dialog
                open={imagenModal}
                onClose={() => setImagenModal(false)}
                PaperProps={{
                    style: {
                        backgroundColor: '#0f172a',
                        color: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        maxWidth: '500px',
                    },
                }}
            >
                <Typography sx={{ fontWeight: 'bold', mb: 2 }}>
                    📸 REVISÁ LA IMAGEN
                </Typography>

                {/* 👉 Imagen dentro del diálogo */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 3,
                    }}
                >
                    <img
                        src={previewImage}
                        alt="preview"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '350px',
                            borderRadius: '10px',
                            objectFit: 'contain',
                        }}
                    />
                </Box>



                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setImagenModal(false);
                            // si querés hacer algo más luego de aceptar, lo agregás acá
                        }}
                        sx={{ backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' } }}
                    >
                        Listo
                    </Button>


                </Box>
            </Dialog>

        </Grid>

    );
}

export default TipeoCustom;
